import { render, staticRenderFns } from "./AreaSchoolSelect.vue?vue&type=template&id=0aab81eb"
import script from "./AreaSchoolSelect.vue?vue&type=script&lang=js"
export * from "./AreaSchoolSelect.vue?vue&type=script&lang=js"
import style0 from "./AreaSchoolSelect.vue?vue&type=style&index=0&id=0aab81eb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports